import { addBreadcrumb, captureConsoleIntegration, init } from "@sentry/react";
import { createRoot } from "react-dom/client";
import { RouterProvider, createBrowserRouter, createRoutesFromElements } from "react-router";
import { config } from "./config";
import { Routes } from "./routes";
import { setSupabaseBreadcrumbSink } from "./server/supabase/breadcrumbs";

// oxlint-disable-next-line import/no-unassigned-import -- Brings `react` into scope for the module augmentation below
import "react";

declare module "react" {
  export interface HTMLAttributes<T> {
    [dataAttribute: `data-${string}`]: string;
  }
}

init({
  ...config.sentry,
  integrations: [captureConsoleIntegration({ levels: ["error", "assert"] })],
});

setSupabaseBreadcrumbSink(addBreadcrumb);

const router = createBrowserRouter(createRoutesFromElements(Routes));

const root = createRoot(document.getElementById("root")!);
root.render(<RouterProvider router={router} />);
